import { render, staticRenderFns } from "./TableOrderComponent.vue?vue&type=template&id=f3b73688&scoped=true"
import script from "./TableOrderComponent.vue?vue&type=script&lang=js"
export * from "./TableOrderComponent.vue?vue&type=script&lang=js"
import style0 from "./TableOrderComponent.vue?vue&type=style&index=0&id=f3b73688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b73688",
  null
  
)

export default component.exports